import React from 'react';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import { components, type MenuListComponentProps } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';

import type { OptionType } from '../../../../../common/ui/custom-select-components/utils';
import messages from './messages';

export type MenuWithFooterProps = MenuListComponentProps<OptionType, true> & {
	showSelectAll: boolean;
	onSelectAllClick: () => void;
};

export const MenuWithFooter = (props: MenuWithFooterProps) => {
	const { showSelectAll, onSelectAllClick, children, ...restProps } = props;
	const { formatMessage } = useIntl();

	return (
		<>
			<components.MenuList {...restProps}>{children}</components.MenuList>
			{showSelectAll && (
				<Box padding="space.100" xcss={footerStyle}>
					<Box paddingInline="space.050">
						<Button appearance="link" spacing="compact" onClick={onSelectAllClick}>
							{formatMessage(messages.selectAllOption)}
						</Button>
					</Box>
				</Box>
			)}
		</>
	);
};

const footerStyle = xcss({
	borderTop: `1px solid ${token('color.border', '#dfe1e6')}`,
});
